import { LocaleLink } from "@/components/LocaleLink";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEOHead from "@/components/seo/SEOHead";
import JsonLd from "@/components/seo/JsonLd";
import {
  ArrowRight,
  Search,
  BadgeCheck,
  HandCoins,
  Shield,
  FileCheck,
  CreditCard,
  Scale,
} from "lucide-react";

const Qualitaetsversprechen = () => {
  const { t } = useTranslation();

  const sections = [
    {
      icon: Search,
      title: t("quality.sec1Title"),
      desc: t("quality.sec1Desc"),
      items: [
        t("quality.sec1Item1"),
        t("quality.sec1Item2"),
        t("quality.sec1Item3"),
        t("quality.sec1Item4"),
      ],
    },
    {
      icon: BadgeCheck,
      title: t("quality.sec2Title"),
      desc: t("quality.sec2Desc"),
      items: [
        t("quality.sec2Item1"),
        t("quality.sec2Item2"),
        t("quality.sec2Item3"),
        t("quality.sec2Item4"),
      ],
    },
    {
      icon: CreditCard,
      title: t("quality.sec3Title"),
      desc: t("quality.sec3Desc"),
      items: [
        t("quality.sec3Item1"),
        t("quality.sec3Item2"),
        t("quality.sec3Item3"),
      ],
    },
    {
      icon: Scale,
      title: t("quality.sec4Title"),
      desc: t("quality.sec4Desc"),
      items: [
        t("quality.sec4Item1"),
        t("quality.sec4Item2"),
        t("quality.sec4Item3"),
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-background" id="main-content">
      <SEOHead
        title={t("quality.seoTitle")}
        description={t("quality.seoDesc")}
        canonical="/qualitaetsversprechen"
      />
      <JsonLd
        includeService
        breadcrumbs={[
          { name: "CRAFTFINDUS", url: "https://www.craftfindus.com/" },
          { name: t("quality.seoTitle"), url: "https://www.craftfindus.com/de/qualitaetsversprechen" },
        ]}
      />
      <Header />

      {/* Hero */}
      <section className="pt-32 pb-16 md:pb-20 section-padding text-center">
        <div className="max-w-3xl mx-auto space-y-6">
          <span className="text-micro tracking-[0.15em]">{t("quality.heroLabel")}</span>
          <h1 className="text-display">
            {t("quality.heroTitle1")}<br />
            <span className="text-accent">{t("quality.heroTitle2")}</span>
          </h1>
          <p className="text-caption text-lg max-w-xl mx-auto leading-relaxed">
            {t("quality.heroDesc")}
          </p>
        </div>
      </section>

      {/* Sections */}
      {sections.map((sec, idx) => (
        <section key={idx} className="section-padding py-16 md:py-20 border-t border-border">
          <div className="max-w-3xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <sec.icon className="w-6 h-6 text-accent" />
              <h2 className="text-subheadline">{sec.title}</h2>
            </div>
            <p className="text-caption leading-relaxed mb-6">{sec.desc}</p>
            <ul className="space-y-3">
              {sec.items.map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-sm">
                  <FileCheck className="w-4 h-4 text-accent shrink-0 mt-0.5" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </section>
      ))}

      {/* CTA */}
      <section className="section-padding py-20 border-t border-border text-center">
        <div className="max-w-2xl mx-auto space-y-6">
          <h2 className="text-headline">{t("quality.ctaTitle")}</h2>
          <p className="text-caption leading-relaxed">{t("quality.ctaDesc")}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <LocaleLink to="/inquiry">
              <Button variant="commit" size="lg" className="group w-full sm:w-auto">
                {t("quality.ctaClientBtn")}
                <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
              </Button>
            </LocaleLink>
            <LocaleLink to="/registrieren">
              <Button variant="quiet" size="lg" className="w-full sm:w-auto">
                {t("quality.ctaProviderBtn")}
                <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
              </Button>
            </LocaleLink>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Qualitaetsversprechen;
